enum Action {
  FETCH_PAYMENTS_CALCULATION = 'fetchPaymentsCalculation',
}

export default Action;
